module.exports = __webpack_public_path__ + "img/bluesky3100_26.a10fd9a6.jpg";